var map = {
	"./music-instructions.json": 3562,
	"./music-library-intro2024.json": 3563,
	"./music-library-launch2024.json": 3564,
	"./music-progression.json": 3565,
	"./startSourcesAdvanced.json": 3566,
	"./startSourcesSimple.json": 3567,
	"./startSourcesSimple2.json": 3568,
	"./startSourcesTracks.json": 3569
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3421;